import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  id?: string;
}
export const SectionWrapper: React.FC<SectionWrapperProps> = ({
  children,
  className = '',
  id
}) => {
  return <section id={id} className={`py-16 md:py-24 px-6 w-full ${className}`} data-id="element-145">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto w-full" data-id="element-146">
        {children}
      </motion.div>
    </section>;
};